import { Dispatch, SetStateAction, useCallback, useState } from "react";
import { Button } from "reactstrap";

import SharedFiltersButtonWithOptions from "../../../components/PageView/PageViewTable/SharedToolbar/SharedFiltersButtonWithOptions";
import SharedSortBy from "../../../components/PageView/PageViewTable/SharedToolbar/SharedSortBy";
import { Search } from "../../../components/PageView/PageViewTable/SharedToolbar/SharedToolbar";
import BrieVoiceCommands from "../../brie/BrieAssist/BrieVoiceCommands";
import { RecordFileCaptureProps } from "../GrowthDriveInterfaces";
import { FileInterface } from "../../../types/RecordInterfaces";
import UppyModal from "../../../components/Modals/UppyModal";
import LibraryLayoutSelector from "./LibraryLayoutSelector";
import { Module } from "../../../types/TenantInterfaces";
import MobileScreenOptions from "./MobileScreenOptions";
import { LibraryViewType } from "../Library";

interface Props {
  query: any;
  setQuery: Dispatch<SetStateAction<any>>;
  simpleSearchQuery: any;
  setSimpleSearchQuery: Dispatch<SetStateAction<any>>;
  simpleSearchValue: string;
  setSimpleSearchValue: Dispatch<SetStateAction<string>>;
  module: Module;
  setViewType: Dispatch<SetStateAction<LibraryViewType>>;
  viewType: LibraryViewType;
  fileFieldPrivacySetting?: boolean; // For adding a file to Growth Drive, from a File Field.
  fromGCRecord: boolean; // For adding a file to Growth Drive, from a GC Record.
  onIndexFiles?: (setIndexing: Dispatch<SetStateAction<boolean>>) => void;
  handleRecordFileCapture: (payload: RecordFileCaptureProps) => void;
  filesToFilter: FileInterface[] | undefined;
}

function LibraryToolbar({
  handleRecordFileCapture,
  setSimpleSearchQuery,
  setSimpleSearchValue,
  onIndexFiles,
  setViewType,
  setQuery,
  query,
  simpleSearchQuery,
  simpleSearchValue,
  module,
  viewType,
  fileFieldPrivacySetting,
  filesToFilter = [],
  fromGCRecord,
}: Props) {
  const [openUppyModal, setOpenUppyModal] = useState(false);

  const updateSortBy = useCallback((sortBy: any) => {
    let q = query;
    let otherQ = simpleSearchQuery;

    q.OrderBy = sortBy ? sortBy : null;
    otherQ && (otherQ.OrderBy = q.OrderBy);

    if (q.OrderBy === null) {
      delete q.OrderBy;
    }

    if (otherQ && otherQ.OrderBy === null) {
      delete otherQ.OrderBy;
    }

    q = { ...q };
    otherQ && (otherQ = { ...otherQ });

    otherQ && setSimpleSearchQuery(otherQ);
    setQuery(q);
  }, []);

  return (
    <div className="tw:flex tw:flex-wrap tw:justify-between tw:gap-3 tw:w-fit">
      {/* TODO: Use this whisper, when more options (Other than "Files") are available. */}
      {/* <Whisper
        trigger="click"
        placement="autoVerticalStart"
        ref={uploadRef}
        preventOverflow
        speaker={
          <Popover className="sidebar-popover">
            <PopoverDropdownMenu>
              <DropdownOptionWithIcon
                name="Folder"
                onClick={() => {}}
                icon="mdi mdi-folder-outline"
              />
              <DropdownOptionWithIcon
                name="Page"
                onClick={() => {}}
                icon="mdi mdi-file-table-box-outline"
              />
              <DropdownOptionWithIcon
                name="GC Document"
                onClick={() => {}}
                icon="mdi mdi-file-document-outline"
              />
              <DropdownOptionWithIcon
                name="Files"
                onClick={() => {
                  uploadRef.current.close();
                  setOpenUppyModal(true);
                }}
                icon="mdi mdi-upload"
              />
            </PopoverDropdownMenu>
          </Popover>
        }
      >
        <Button size="sm" color="primary" className="tw:m-0">
          Add File
        </Button>
      </Whisper> */}
      <Button
        size="sm"
        color="primary"
        className="tw:m-0"
        onClick={() => {
          setOpenUppyModal(true);
        }}
      >
        Add File
      </Button>
      {fromGCRecord && (
        <MobileScreenOptions
          onIndexFiles={onIndexFiles}
          handleRecordFileCapture={handleRecordFileCapture}
        />
      )}
      <BrieVoiceCommands />
      <Search
        clearSimpleSearch={() => setSimpleSearchValue("")}
        query={query}
        currentModule={module!}
        setSimpleSearchQuery={setSimpleSearchQuery}
        setSimpleSearchValue={setSimpleSearchValue}
        isMobile={true}
      />
      <SharedFiltersButtonWithOptions
        currentModule={module}
        query={query}
        setQuery={setQuery}
        simpleSearchValue={simpleSearchValue}
        setSimpleSearchValue={setSimpleSearchValue}
        clearSimpleSearch={() => setSimpleSearchValue("")}
        view={
          {
            ModuleAPIName: module?.APIName,
          } as any
        }
      />
      <SharedSortBy
        query={query}
        updateSortBy={updateSortBy}
        view={
          {
            ModuleAPIName: module?.APIName,
          } as any
        }
      />
      <LibraryLayoutSelector setViewType={setViewType} viewType={viewType} />
      <UppyModal
        open={openUppyModal}
        onClose={() => {
          setOpenUppyModal(false);
        }}
        afterSubmit={
          fromGCRecord
            ? (files) => handleRecordFileCapture({ type: "Uppy", files })
            : undefined
        }
        fileFieldPrivacySetting={fileFieldPrivacySetting}
        showFileExplorerButton={fromGCRecord ? true : false}
        filesToFilter={filesToFilter}
      />
    </div>
  );
}

export default LibraryToolbar;
